/* Olyra Blister Sleeve — comportement des sections olyra-bs-* (sans dépendance). */
(function () {
  function initBuy(root) {
    root.querySelectorAll('[data-olyra-bs-buy]').forEach(function (buy) {
      if (buy.dataset.ready) return;
      buy.dataset.ready = '1';
      var dataEl = buy.querySelector('[data-olyra-bs-variants]');
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
      var idInput = buy.querySelector('input[name="id"]');
      var button = buy.querySelector('[data-olyra-bs-add]');
      var label = buy.querySelector('[data-olyra-bs-add-label]');
      function sync() {
        var picked = [];
        buy.querySelectorAll('[data-olyra-bs-option]').forEach(function (group) {
          var input = group.querySelector('input:checked');
          var out = group.querySelector('[data-olyra-bs-option-value]');
          if (input) { picked.push(input.value); if (out) out.textContent = input.value; }
        });
        var match = variants.filter(function (v) {
          return v.options.every(function (o, i) { return o === picked[i]; });
        })[0];
        if (!match) return;
        idInput.value = match.id;
        buy.dataset.variant = match.id;
        if (button) {
          button.disabled = !match.available;
          if (label) label.textContent = match.available ? button.dataset.label : button.dataset.labelSoldout;
        }
        if (window.history && history.replaceState && !window.Shopify?.designMode) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url.toString());
        }
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      buy.addEventListener('change', function (e) {
        if (e.target.closest('[data-olyra-bs-option]')) sync();
      });
      /* Dès que l'appli de lots affiche son bloc (où qu'elle le pose dans le bloc d'achat), les sélecteurs du thème se masquent :
         l'appli porte les siens, paire par paire. Si elle ne rend pas, ils restent visibles et l'on peut acheter une paire. */
      if ('MutationObserver' in window) {
        var check = function () {
          var live = Array.prototype.some.call(buy.querySelectorAll('moonbundle-component, .moonbundle-box, [data-olyra-bs-bundle-slot] > :not(.moonbundleCustomLoader)'), function (el) {
            return el.offsetHeight > 40;
          });
          buy.classList.toggle('olyra-bs-buy--bundled', live);
          if (live) buy.classList.remove('olyra-bs-buy--waiting');
        };
        window.setTimeout(function () { buy.classList.remove('olyra-bs-buy--waiting'); }, 4000);
        new MutationObserver(check).observe(buy, { childList: true, subtree: true });
        check();
      }
    });
  }

  function initGallery(root) {
    root.querySelectorAll('[data-olyra-bs-gal]').forEach(function (gal) {
      if (gal.dataset.ready) return;
      gal.dataset.ready = '1';
      var track = gal.querySelector('[data-olyra-bs-gal-track]');
      var slides = gal.querySelectorAll('[data-olyra-bs-gal-slide]');
      var thumbs = gal.querySelectorAll('[data-olyra-bs-gal-thumb]');
      function mark(i) {
        thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      }
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
          mark(i);
        });
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) mark(Array.prototype.indexOf.call(slides, en.target));
          });
        }, { root: track, threshold: 0.6 });
        slides.forEach(function (s) { io.observe(s); });
      }
    });
  }

  /* Agrandissement d'une image de galerie : fenêtre native, image à 2 000 px que l'on fait défiler ou que l'on pince. */
  function initZoom(root) {
    root.querySelectorAll('[data-olyra-bs-zoom]').forEach(function (btn) {
      if (btn.dataset.ready) return;
      btn.dataset.ready = '1';
      btn.addEventListener('click', function () {
        var dialog = document.querySelector('[data-olyra-bs-zoom-dialog]');
        if (!dialog || !dialog.showModal) return;
        var img = dialog.querySelector('[data-olyra-bs-zoom-img]');
        img.src = btn.dataset.olyraBsZoom;
        img.alt = btn.dataset.alt || '';
        dialog.showModal();
        var pane = dialog.querySelector('.olyra-bs-zoom__pane');
        pane.scrollTop = 0; pane.scrollLeft = 0;
      });
    });
    root.querySelectorAll('[data-olyra-bs-zoom-dialog]').forEach(function (dialog) {
      if (dialog.dataset.ready) return;
      dialog.dataset.ready = '1';
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    });
  }

  function initReviews(root) {
    root.querySelectorAll('[data-olyra-bs-reviews]').forEach(function (sec) {
      if (sec.dataset.ready) return;
      sec.dataset.ready = '1';
      var track = sec.querySelector('[data-olyra-bs-reviews-track]');
      if (!track) return;
      var go = function (dir) { track.scrollBy({ left: dir * Math.max(280, track.clientWidth * 0.8), behavior: 'smooth' }); };
      var prev = sec.querySelector('[data-olyra-bs-reviews-prev]'), next = sec.querySelector('[data-olyra-bs-reviews-next]');
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
    });
  }

  function initSticky(root) {
    root.querySelectorAll('[data-olyra-bs-sticky]').forEach(function (bar) {
      if (bar.dataset.ready) return;
      bar.dataset.ready = '1';
      document.body.classList.add('olyra-bs--has-sticky');
      /* Page produit : la barre est visible dès que le bouton principal n'est pas à l'écran. Ailleurs : après 300 px de défilement. */
      var anchor = document.querySelector('[data-olyra-bs-add]');
      var show = function (on) { bar.classList.toggle('is-on', on); };
      if (anchor && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          show(!entries[0].isIntersecting);
        }).observe(anchor);
      } else {
        var onScroll = function () { show(window.scrollY > 300); };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }
      var submit = bar.querySelector('[data-olyra-bs-sticky-submit]');
      if (submit) {
        submit.addEventListener('click', function () {
          var form = document.querySelector('[data-olyra-bs-buy] form') || document.querySelector('form[data-olyra-bs-buy]');
          if (form) { if (form.requestSubmit) form.requestSubmit(); else form.submit(); }
        });
      }
    });
  }

  function initLinks(root) {
    root.querySelectorAll('[data-olyra-bs-open]').forEach(function (link) {
      if (link.dataset.ready) return;
      link.dataset.ready = '1';
      link.addEventListener('click', function (e) {
        var target = document.querySelector('[data-olyra-bs-acc="' + link.dataset.olyraBsOpen + '"]');
        if (!target) return;
        e.preventDefault();
        target.open = true;
        target.scrollIntoView({ block: 'center' });
        var s = target.querySelector('summary');
        if (s) s.focus({ preventScroll: true });
      });
    });
  }

  function init(root) { initBuy(root); initGallery(root); initZoom(root); initReviews(root); initSticky(root); initLinks(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
